import type { AreaRoute } from "./areaRoute";
import { SchedulePublishers } from "../../auth/roles";
import { lazyPage } from "../../lib/lazyPage";
const ApproveInTeamsPage = lazyPage(() => import("../approve/ApproveInTeamsPage"), "ApproveInTeamsPage");
const RequestTeamsApprovalForm = lazyPage(() => import("../approve/RequestTeamsApprovalForm"), "RequestTeamsApprovalForm");
const TeamsApprovalsAdminPanel = lazyPage(() => import("../approve/TeamsApprovalsAdminPanel"), "TeamsApprovalsAdminPanel");

export { ApproveInTeamsPage, RequestTeamsApprovalForm, TeamsApprovalsAdminPanel };

/**
 * Teams area (W8, D-O85): the Approve in Teams confirm page. Inside the application frame and signed in — a Teams card's
 * "Approve…" / "Decline…" opens it. Only the Planner and the Operations Manager sign these acts (API policy
 * `SchedulePublishers`; the API also refuses anyone but the person the request was sent to). Owned by agent teams-apps; the
 * integrator spreads this list into App.tsx. No hub tab: the page is reached from the card only.
 */
export const teamsRoutes: AreaRoute[] = [{ path: "/approve/:token", allow: SchedulePublishers, element: <ApproveInTeamsPage /> }];
